module.exports = __webpack_public_path__ + "img/CampañasLocales.2c7b9789.svg";